import { useState } from "react";
import PaymentStep from "./PaymentStep";
import BillingStep from "./BillingStep";
import SummaryStep from "./Components/SummaryStep";
import { useCheckout } from "../../../hooks/useCheckout";
import LogoHeader from "../LogoHeader";
import { MultiStepProgressBar } from "../../Popup/MultiStepProgressBar";
import "./CheckOutStep.scss";
import { useLocation } from "react-router-dom";

const CheckoutContainer = () => {
  const [step, setStep] = useState(1);
  const [clientSecret, setClientSecret] = useState(null);
  const state=useLocation()
  const initailData=state?.state || {}
  const checkout = useCheckout(initailData || {});
  const next = () => setStep((s) => s + 1);
  const back = () => setStep((s) => s - 1);

  return (
    <div className="checkout-setp-wrapper">
            <div className="checkout-setp-header">
        <LogoHeader />
      </div>

      <div className="checkout-setp-card">
        <div className="stepper">
          <MultiStepProgressBar step={step} totalSteps={3} />
          <div className="heading mt-5">
            {step === 1 && "Payment Details"}
            {step === 2 && "Billing Details"}
            {step === 3 && "Summary"}
          </div>
        </div>
        {step === 1 && <PaymentStep {...checkout} next={next} />}
        {step === 2 && <BillingStep {...checkout} next={next} back={back} setClientSecret={setClientSecret} />}
        {step === 3 && <SummaryStep {...checkout} back={back} clientSecret={clientSecret}/>}

      </div>
    </div>
  );
};

export default CheckoutContainer;